import { Box } from '@mui/material';
import { Labeled, NumberFieldProps, RaRecord, TextField } from 'react-admin';
import { locale, numberFormatConfiguration } from './numberFormatConfiguration';

export type QuickbooksCalculatedPriceFieldProps = NumberFieldProps & {
  price: number;
  source: string;
};

export const QuickbooksCalculatedPriceField = (
  props: QuickbooksCalculatedPriceFieldProps
) => {
  const totalRecord: RaRecord = {
    id: 0,
  };
  totalRecord[props.source] = Intl.NumberFormat(
    locale,
    numberFormatConfiguration
  ).format(props.price);
  return (
    <Box sx={{ marginBottom: '20px' }}>
      <Labeled>
        <TextField record={totalRecord} {...props} />
      </Labeled>
    </Box>
  );
};
